import React, {useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';
import MainRouter from "./router/MainRouter";
import {CssBaseline, ThemeProvider} from "@mui/material";
import {checkLoginStatus} from "./utils/userSlice";
import {CacheProvider} from '@emotion/react';
import createCache from '@emotion/cache';
import {prefixer} from 'stylis';
import rtlPlugin from 'stylis-plugin-rtl';
import {MobileProvider} from './context/MobileContext';
import MainRoutes from "./router/MainRoutes";
import {I18nextProvider, useTranslation} from 'react-i18next';
import {ltrTheme, rtlTheme} from "./utils/theme";
import {normalizeLanguage} from "./utils/language";

// import LinkList from './components/LinkList';
const cacheRtl = createCache({
    key: 'muirtl',
    stylisPlugins: [prefixer, rtlPlugin],
});

const cacheLtr = createCache({
    key: 'muiltr',
    stylisPlugins: [prefixer], // No RTL plugin for LTR
});


const App: React.FC = () => {
    const dispatch = useDispatch();
    const {i18n} = useTranslation();

    const [direction, setDirection] = useState('ltr')

    useEffect(() => {
        dispatch(checkLoginStatus());
    }, [dispatch]);

    useEffect(() => {
        // Normalize whatever is stored — a stray 'he-IL'/'iw' would load Hebrew
        // TEXT (via fallbackLng) but fail the exact-match direction check below,
        // rendering Hebrew in an LTR layout. RequireAuth re-syncs this from the
        // account language after login.
        const preferredLanguage = normalizeLanguage(localStorage.getItem('lang'));
        i18n.changeLanguage(preferredLanguage ?? 'en');
    }, []);

    useEffect(() => {
        // This function will run every time the language changes
        const dir = i18n.dir(); // rtl for he (and any he-* that slips through)
        setDirection(dir)
        document.documentElement.setAttribute('dir', dir); // Set the dir attribute on the <html> element
        document.documentElement.setAttribute('lang', i18n.language); // Set the dir attribute on the <html> element
    }, [i18n.language]); // Dependency array includes `i18n.language`

    return (
        <I18nextProvider i18n={i18n}>
            <CacheProvider value={direction === 'rtl' ? cacheRtl : cacheLtr}>
                <ThemeProvider theme={direction === 'rtl' ? rtlTheme : ltrTheme}>
                    <MobileProvider>
                        <CssBaseline/>
                        <MainRouter>
                            <MainRoutes/>
                        </MainRouter>
                    </MobileProvider>
                </ThemeProvider>
            </CacheProvider>
        </I18nextProvider>
    )
}

export default App;
